import { useState } from "react";
import { motion } from "framer-motion";
import { Expand, X } from "lucide-react";
import flyer from "@/assets/postponed-flyer.jpeg";

export const ChurchFlyer = () => {
  const [open, setOpen] = useState(false);

  return (
    <section id="welcome-flyer" data-testid="church-flyer-section" className="relative py-20 sm:py-28 px-6 sm:px-10">
      <div className="max-w-3xl mx-auto text-center">
        <motion.button
          onClick={() => setOpen(true)}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          data-testid="church-flyer-thumb"
          className="group relative block w-full overflow-hidden border border-[#D4AF37]/30 shadow-[0_25px_70px_rgba(0,0,0,0.6)]"
        >
          <img src={flyer} alt="The Change Center Church" className="w-full h-auto transition-transform duration-700 group-hover:scale-[1.02]" />
          <span className="absolute inset-0 bg-[#06040A]/0 group-hover:bg-[#06040A]/20 transition-colors flex items-center justify-center">
            <span className="opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-2 bg-[#06040A]/80 text-[#D4AF37] px-4 py-2 text-sm uppercase tracking-wider border border-[#D4AF37]/40">
              <Expand className="h-4 w-4" /> Tap To Enlarge
            </span>
          </span>
          <div
            data-testid="postponed-banner"
            className="absolute bottom-0 inset-x-0 bg-[#C1121F] text-white text-center py-3 sm:py-4 px-4 shadow-[0_-6px_20px_rgba(0,0,0,0.5)]"
          >
            <p className="font-semibold uppercase tracking-[0.15em] text-sm sm:text-base leading-snug">
              This Event Has Been Postponed · New Date Coming Soon
            </p>
          </div>
        </motion.button>
      </div>

      {open && (
        <div
          className="fixed inset-0 z-[100] bg-[#06040A]/95 backdrop-blur-sm flex items-center justify-center p-4 sm:p-10"
          onClick={() => setOpen(false)}
          data-testid="church-flyer-modal"
        >
          <button onClick={() => setOpen(false)} data-testid="church-flyer-close" className="absolute top-6 right-6 text-[#D4AF37] hover:text-[#F3D56D] transition-colors" aria-label="Close">
            <X className="h-8 w-8" />
          </button>
          <img src={flyer} alt="The Change Center Church" onClick={(e) => e.stopPropagation()} className="max-h-[90vh] w-auto border border-[#D4AF37]/40 shadow-2xl" />
        </div>
      )}
    </section>
  );
};
